import {
  ApiResponse,
  BodySite,
  ONE_HOUR_IN_MS,
  Pathology,
  ScoringSystem,
  getBodySitesQueryKey,
  getScoringSystemsQueryKey
} from '@legit.health/ui';
import {useQueryClient} from '@tanstack/react-query';
import useLoggedUserContext from '@/shared/contexts/UserContext/useUserContext';
import useApiQuery from '@/shared/hooks/useApiQuery';
import {getQueryKey as getPathologiesQueryKey} from './usePathologies';
import cachedDataState from './utils/cachedDataState';

const PATH = '/app-info';

export default function useAppInfo() {
  const {user} = useLoggedUserContext();
  const queryClient = useQueryClient();
  return useApiQuery<{
    dataImportedAt: string;
  }>({
    queryOptions: {
      queryKey: [PATH],
      staleTime: ONE_HOUR_IN_MS,
      onSuccess(response) {
        const {dataImportedAt, bodySites, pathologies, scoringSystems, locale} =
          cachedDataState.get();
        if (dataImportedAt !== response.data.dataImportedAt || locale !== user.locale) {
          cachedDataState.set(() => ({
            dataImportedAt: response.data.dataImportedAt,
            locale: user.locale
          }));
          return;
        }
        if (!bodySites || !pathologies || !scoringSystems) {
          return;
        }
        queryClient.setQueryData<ApiResponse<BodySite[]> | null>(getBodySitesQueryKey(), {
          isSuccessfull: true,
          status: 200,
          data: bodySites
        });
        queryClient.setQueryData<ApiResponse<Pathology[]> | null>(getPathologiesQueryKey(), {
          isSuccessfull: true,
          status: 200,
          data: pathologies
        });
        queryClient.setQueryData<ApiResponse<ScoringSystem[]> | null>(getScoringSystemsQueryKey(), {
          isSuccessfull: true,
          status: 200,
          data: scoringSystems
        });
      },
      suspense: true
    },
    requestArguments: {
      method: 'GET',
      path: PATH
    }
  });
}
